module.exports = require('../lib/plugins/container');